var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaverBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.54,
    height: 20.896,
    viewBox: "0 0 22.54 20.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 83212",
    d: "M3.9 5.82a.784.784 0 0 0-.78.78.782.782 0 1 0 .78-.78z",
    transform: "translate(1.017 1.897)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9432",
    cx: 0.835,
    cy: 0.835,
    r: 0.835,
    transform: "translate(11.747 7.637)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 83213",
    d: "M19.53 0H3.01A3.016 3.016 0 0 0 0 3.01v9.8a3.008 3.008 0 0 0 3.01 3.01h5.834l1.989 4.667s.133.411.464.411.464-.411.464-.411l1.989-4.667h5.78a3.008 3.008 0 0 0 3.01-3.01v-9.8A3.008 3.008 0 0 0 19.53 0zM7.08 8.658A1.86 1.86 0 0 1 5.224 10.5a1.568 1.568 0 0 1-1.124-.476v.318H2.745V4.786c.08.013 1.352 0 1.352 0v2.122c.318-.544 1.233-.53 1.233-.53a1.974 1.974 0 0 1 1.75 2.28zM9.454 6.55v3.805H8.128V6.59c0-.517-.636-.65-.636-.65V4.614a1.831 1.831 0 0 1 1.962 1.949zm3.129 3.95a2.136 2.136 0 0 1-2.214-2.042 2.136 2.136 0 0 1 2.214-2.042A2.136 2.136 0 0 1 14.8 8.459a2.136 2.136 0 0 1-2.217 2.041zm7.226 0a1.889 1.889 0 0 1-1.949 1.936h-.6v-1.26h.358s.822.08.822-1.193c0 0-.159.517-1.326.517a1.743 1.743 0 0 1-1.644-1.724v-.61a1.876 1.876 0 0 1 1.843-1.79 1.336 1.336 0 0 1 1.154.517v-.409h1.339V10.5z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9433",
    cx: 0.822,
    cy: 0.822,
    r: 0.822,
    transform: "translate(16.892 7.65)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverBlog);
export default __webpack_public_path__ + "static/media/naver-blog.933a9403fc4afb50b26f271c32d6dcdd.svg";
export { ForwardRef as ReactComponent };